import React, { useState, useEffect } from 'react';

import axios from 'axios';
import moment from 'moment';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import BlockUi from 'react-block-ui';
import { connect } from 'react-redux';
import { Loader } from 'react-loaders';
import { Link } from 'react-router-dom';

import { updateApiPara } from '@redux/overnight-camp-data-apiParameter/action';
import { getOvernightCampReopenReport } from '@redux/overnight-camp-data-review-and-submit/action';
import { getOvernightCampBranchDetails } from '@redux/overnight-camp-data-report-dashboard/action';

import GetModulesConfigSelector from '@redux/module-config/selectors';
import { AssociationNumberSelector } from '@redux/dashboard/selectors';
import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';
import { OvernightCampBranchDetailsDashboardSelector } from '@redux/overnight-camp-data-report-dashboard/selectors';

import { DOWNLOAD_CAMP_PDF } from '@config/api-config';
import { APP_LABELS, STORAGE_KEYS } from '@config/app-config';

import CustomModal from '@utilities/CustomModal';
import SecureStorage from '@utilities/SecureStorage';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';

import BackIcon from '@static/images/back-icon.svg';
import successIcon from '@static/images/success_icon.svg';
import loadingIcon from '@static/images/loading_icon.svg';
import blueDotIcon from '@static/images/blue-dot-icon.svg';
import dropdownIcon from '@static/images/dropdown-icon.svg';
import downloadPdfIcon from '@static/images/download-pdf.svg';

import Card from './Card';

const DatesElement = reportData => (
  <div className="col-md-3 YMCA-flexxey">
    <div className="notranslate">
      <div className="date_head">
        <h6>Start Date</h6>
      </div>
      <div className="date">
        <p>
          {reportData?.startDate
            ? moment(reportData?.startDate).format('MMMM DD, YYYY')
            : '-'}
        </p>
      </div>
    </div>
    <div className="notranslate">
      <div className="date_head">
        <h6>End Date</h6>
      </div>
      <div className="date">
        <p>
          {reportData?.endDate
            ? moment(reportData?.endDate).format('MMMM DD, YYYY')
            : '-'}
        </p>
      </div>
    </div>
  </div>
);

const handleSetYear = selectedBatchYear => {
  sessionStorage.setItem('selectedBatchYear', selectedBatchYear);
};

const DownloadElement = (reportData, downloadPdfApi) => (
  <div className="col-md-3 mb-3">
    <div className="date_head ms-5">
      <h6>Report</h6>
    </div>
    <div className="c-pointer status-icon ymca-success-text d-flex align-items-center ms-5 ymca-annualReport ">
      <img src={downloadPdfIcon} alt="download-pdf-icon" className="me-1" />
      <button
        type="button"
        className="success-hover borderNone"
        onClick={() => downloadPdfApi(reportData?.year)}
      >
        Download Pdf
      </button>
    </div>
  </div>
);

const statusElement = (
  reportData,
  role,
  selectedBatchYear,
  setSelectedBatchYear,
  handleUpdateApiPara,
  setReOpenYear,
  setAlertPopup,
  allCampBranchDashboardData
) => {
  const location = {
    pathname: '/overnight-camp-data/reports',
    state: { selectedYear: reportData?.year }
  };

  return (
    <div
      className={`${
        ((role === APP_LABELS.YUSA_DATA_STEWARD ||
          role === APP_LABELS.YUSA_DATA_VIEWER ||
          role === APP_LABELS.ALLIANCE_DATA_STEWARD) &&
          reportData?.status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED) ||
        reportData?.status?.toUpperCase() === APP_LABELS.STATUS_YETTOBEGIN
          ? 'col-md-3'
          : 'col-md-2 mb-3'
      }`}
    >
      <div className="progress_link align-items-center d-flex mt-2 YMCA-flexxey">
        {role === APP_LABELS.YUSA_DATA_STEWARD &&
          reportData?.status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED && (
            <div className="ml-60">
              <button
                type="button"
                className="btn btn-transparent ymca-link text-decoration-none ymca-unsubmit"
                onClick={() => {
                  setReOpenYear(reportData?.year);
                  setAlertPopup(true);
                }}
              >
                Re-open
              </button>
            </div>
          )}

        <div>
          <div className="date_head">
            <h6>Status</h6>
          </div>
          {selectedBatchYear === reportData?.year ? (
            <Link
              to={location}
              onClick={() => handleSetYear(selectedBatchYear)}
            >
              View Progress
            </Link>
          ) : (
            <button
              type="button"
              className="btn btn-transparent ymca-link text-decoration-none p-0 mb-1"
            >
              <img
                src={blueDotIcon}
                alt="blue-dot-icon"
                className="me-1 mb-1"
              />
              {reportData?.status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED
                ? 'Submitted'
                : 'In Progress'}
            </button>
          )}
          <button
            type="button"
            className="btn btn-transparent mb-1"
            onClick={() => {
              if (selectedBatchYear) setSelectedBatchYear(null);
              else {
                setSelectedBatchYear(reportData?.year);
                handleUpdateApiPara({
                  year: reportData?.year,
                  reportBatchId: allCampBranchDashboardData?.data?.find(
                    item => item.year === reportData?.year
                  )?.reportBatchId
                });
              }
            }}
          >
            <img
              src={dropdownIcon}
              alt="dropdown-icon"
              className={`ms-4 ${
                selectedBatchYear === reportData?.year && 'rotate-180'
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

const HeaderContent = (
  reportData,
  role,
  downloadPdfApi,
  selectedBatchYear,
  setSelectedBatchYear,
  handleUpdateApiPara,
  setReOpenYear,
  setAlertPopup,
  allCampBranchDashboardData
) => (
  <section
    className={`annual-report mt-4 ${
      selectedBatchYear === reportData?.year ? '' : 'annual-report-box'
    }`}
  >
    <div className="row align-items-center">
      <div className="col-md-3">
        <div className="report-2022">
          <h6 className="ymca-annualReportt">Camp {reportData?.year}</h6>
        </div>
      </div>
      {DatesElement(reportData)}

      {reportData?.status?.toUpperCase() === APP_LABELS.STATUS_YETTOBEGIN && (
        <div className="col-md-3" />
      )}
      {reportData?.status?.toUpperCase() !== APP_LABELS.STATUS_YETTOBEGIN &&
        DownloadElement(reportData, downloadPdfApi)}

      {statusElement(
        reportData,
        role,
        selectedBatchYear,
        setSelectedBatchYear,
        handleUpdateApiPara,
        setReOpenYear,
        setAlertPopup,
        allCampBranchDashboardData
      )}
    </div>
  </section>
);

const OverNightCampReportDashboard = props => {
  const {
    LoginUserData,
    ApiParameterData,
    handleReopenReport,
    handleUpdateApiPara,
    allCampBranchDashboardData,
    handleOvernightCampBranchDetailsData
  } = props;

  const role = get(LoginUserData, 'user.role[0]', null);
  const branchData = JSON.parse(
    sessionStorage.getItem('yusa_selected_camp_branch')
  );

  const [selectedBatchYear, setSelectedBatchYear] = useState(
    allCampBranchDashboardData?.data
      ? allCampBranchDashboardData?.data[0]?.year
      : new Date().getFullYear()
  );
  const [loader, setLoader] = useState(false);
  const [alertPopup, setAlertPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [instructions, setInstructions] = useState('');

  const [reOpenYear, setReOpenYear] = useState(null);
  const [afterRevokePopup, setAfterRevokePopup] = useState(false);

  const getOverNightCampReportData = () => {
    setAfterRevokePopup(false);
    setLoader(true);
    handleOvernightCampBranchDetailsData(
      branchData
        ? branchData?.BranchNumber
        : get(LoginUserData, 'user.branches[0]', null)
    ).then(() => {
      setLoader(false);
    });
  };

  const revokeAPICall = () => {
    setAlertPopup(false);
    setReOpenYear(null);
    setLoader(true);
    handleReopenReport(
      ApiParameterData?.branchNumber,
      ApiParameterData?.reportBatchId,
      reOpenYear
    ).then(res => {
      if (res?.data?.isSuccess) {
        handleUpdateApiPara({
          reportBatchId: res?.data?.reportBatchId
        });
        setAfterRevokePopup(true);
      } else {
        setErrorPopup(true);
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    SecureStorage.setItem(
      STORAGE_KEYS.DASHBOARD_URL,
      '/overnight-camp-data/dashboard'
    );
    setInstructions(
      JSON.parse(sessionStorage.getItem('allinstructions'))?.[
        'annual-report-association-dashboard'
      ]?.Instruction
    );
    window.scroll(0, 0);
    if (role === APP_LABELS.BRANCH_DATA_STEWARD) {
      handleUpdateApiPara({
        branchNumber: get(LoginUserData, 'user.branches[0]'),
        reportBatchId: allCampBranchDashboardData?.data
          ? allCampBranchDashboardData?.data[0]?.reportBatchId
          : null,
        year: allCampBranchDashboardData?.data
          ? allCampBranchDashboardData?.data[0]?.year
          : new Date().getFullYear()
      });
    } else {
      handleUpdateApiPara({
        branchNumber: branchData?.BranchNumber,
        reportBatchId: branchData?.ReportBatchId,
        year: branchData?.Year
      });
    }
    getOverNightCampReportData();
  }, [allCampBranchDashboardData?.data === undefined]);

  const downloadPdfApi = year => {
    setLoader(true);
    const authToken = JSON.parse(sessionStorage.getItem('token'));
    const Offset = new Date().getTimezoneOffset();
    axios
      .get(DOWNLOAD_CAMP_PDF(ApiParameterData?.branchNumber, year, Offset), {
        responseType: 'blob',
        headers: {
          'Content-Type': 'blob',
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': window.location.origin,
          'Ocp-Apim-Subscription-Key': APP_LABELS.APIM_KEY,
          Authorization: `Bearer ${get(authToken, 'token', '')}`
        }
      })
      .then(res => {
        const fileName = `${
          allCampBranchDashboardData?.data
            ? allCampBranchDashboardData?.data[0]?.branchName
            : branchData?.CampName
        } - Overnight-Camp.pdf`;
        const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName.replaceAll('"', ''));
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
        setErrorPopup(true);
      });
  };

  return (
    <BlockUi
      blocking={loader}
      message="Loading, please wait"
      loader={<Loader active type="semi-circle-spin" />}
    >
      <main className="page-container">
        <div className="ymca-data-wrapper dashboard-wrapper">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7 col-md-6 col-sm-12">
                <div className="reports_head">
                  <h6 className="ymca-sub-heading">
                    {allCampBranchDashboardData?.data
                      ? allCampBranchDashboardData?.data[0]?.branchName
                      : branchData?.CampName}
                  </h6>
                </div>
              </div>
              {role !== APP_LABELS.BRANCH_DATA_STEWARD && (
                <div className="col-lg-5 col-md-6 col-sm-12 text-lg-end text-md-end">
                  <Link
                    className="ymca-title-link"
                    to="/overnight-camp-data/yusa-dashboard"
                  >
                    <img src={BackIcon} className="me-1 mb-2" alt="back-icon" />{' '}
                    Back
                  </Link>
                </div>
              )}
            </div>

            <section>
              {/* <div className="ymca-sorroundings">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="ymca-instructionBoxes my-0 pb-0 pt-2">
                    <p className="ymca-instructTitle">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: instructions
                        }}
                      />
                    </p>
                  </div>
                </div>
              </div> */}
              <div className="row mt-3 align-items-center">
                <div className="col-lg-7 col-md-7 col-sm-12">
                  {/* <div className="reports_head">
                    <h6 className="ymca-sub-heading">
                      {APP_LABELS.OVERNIGHT_CAMP_DATA}
                    </h6>
                  </div> */}
                </div>
                {selectedBatchYear && (
                  <div className="col-lg-5 col-md-5 col-sm-12 d-flex justify-content-lg-end status-content">
                    <div className="checkbox_content d-flex">
                      <div className="checkbox_1">
                        <img src={successIcon} alt="success" />
                      </div>
                      <div className="content ps-2">
                        <h6>Section Completed</h6>
                        <p>
                          {'(All required fields within'}
                          <br />
                          {' the section are completed)'}
                        </p>
                      </div>
                    </div>
                    <div className="checkbox_content_1 d-flex">
                      <div className="checkbox">
                        <img src={loadingIcon} alt="loading" />
                      </div>
                      <div className="content text-start ps-2">
                        <h6>Section In Progress</h6>
                        <p>
                          {'(Certain fields within the '}
                          <br />
                          {'section are incomplete)'}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </section>

            {Array.isArray(allCampBranchDashboardData?.data) &&
              allCampBranchDashboardData?.data?.map(reportData => {
                if (
                  moment(new Date()).isAfter(reportData?.startDate, true) ||
                  ApiParameterData?.branchNumber === '9999'
                ) {
                  return (
                    <>
                      {HeaderContent(
                        reportData,
                        role,
                        downloadPdfApi,
                        selectedBatchYear,
                        setSelectedBatchYear,
                        handleUpdateApiPara,
                        setReOpenYear,
                        setAlertPopup,
                        allCampBranchDashboardData
                      )}
                      {`${selectedBatchYear}` === reportData?.year && (
                        <section>
                          <div className="row mt-4">
                            {reportData?.dashboardDTOs?.map(dto => (
                              <Card
                                id={
                                  reportData?.year >= '2023'
                                    ? dto?.sequenceNo
                                    : dto.formId
                                }
                                name={dto?.name}
                                status={dto?.status?.toUpperCase()}
                                lastUpdatedBy={dto?.updatedByName}
                                lastUpdatedDate={dto?.updatedDateTime}
                                userRole={role}
                                key={
                                  reportData?.year >= '2023'
                                    ? dto?.sequenceNo
                                    : dto.formId
                                }
                                year={dto?.year}
                              />
                            ))}
                          </div>
                        </section>
                      )}
                    </>
                  );
                }
              })}
          </div>
        </div>
      </main>

      <CustomModal
        show={alertPopup}
        type={APP_LABELS.INFORMATION}
        message="Are you sure you want to re-open Overnight Camp report?"
        submitButtonName="Continue"
        onSubmit={revokeAPICall}
        cancelButtonName={APP_LABELS.UPLOAD_DATA_CANCEL}
        onCancel={() => {
          setAlertPopup(false);
          setReOpenYear(null);
        }}
      />

      <CustomModal
        show={afterRevokePopup}
        message={APP_LABELS.REOPEN_STATUS}
        type={APP_LABELS.SUCCESS}
        submitButtonName={APP_LABELS.OK}
        onSubmit={getOverNightCampReportData}
      />

      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={APP_LABELS.COMMON_ERROR_MESSAGE}
        showErrorPopup={errorPopup}
      />
    </BlockUi>
  );
};

OverNightCampReportDashboard.propTypes = {
  handleReopenReport: PropTypes.func.isRequired,
  handleUpdateApiPara: PropTypes.func.isRequired,
  handleOvernightCampBranchDetailsData: PropTypes.func.isRequired,

  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired,
  allCampBranchDashboardData: PropTypes.arrayOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handleReopenReport: getOvernightCampReopenReport,
  handleOvernightCampBranchDetailsData: getOvernightCampBranchDetails,
  handleUpdateApiPara: updateApiPara
};

const mapStateToProps = state => ({
  ModulesConfigData: GetModulesConfigSelector(state),
  ApiParameterData: ApiParaSelector(state),
  allCampBranchDashboardData:
    OvernightCampBranchDetailsDashboardSelector(state),
  AssociationNumberData: AssociationNumberSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OverNightCampReportDashboard);
